export default __webpack_public_path__ + "static/media/mobile6.12fd2df7.webp";